import { useContext, useEffect, useState } from 'react';
import TooltipContext from '@components/core/tooltip/tooltip-context.tsx';

const useTooltipContainer = () => {
	const ref = useContext(TooltipContext);
	const [container, setContainer] = useState<HTMLElement | null>(null);

	useEffect(() => {
		if (ref?.current) {
			setContainer(ref.current);
		}
	}, [ref]);

	return container;
};

export default useTooltipContainer;
